import { joinPath } from '../../core/utils';
import type { StartupCommandArgsBlockOptions, StartupCommandArgsPaths } from './types';

export function resolveStartupCommandArgsPaths(prefix: string, options?: StartupCommandArgsBlockOptions): StartupCommandArgsPaths {
  const commandSegment = options?.commandSegment ?? 'command';
  const listSegment = options?.listSegment ?? 'startupArgs';
  return {
    command: joinPath(prefix, commandSegment),
    list: joinPath(prefix, listSegment),
  };
}
